module.exports = __webpack_public_path__ + "img/left-arrow3.39988b27.svg";